import { Suspense } from "react"
import { faShieldCheck } from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { QueryErrorBoundary } from "../../../../../core/api/components/QueryErrorBoundary"
import { LoadingSpinner } from "../../../../../shared/components/loading/LoadingSpinner"
import { PageHeader } from "../../../../../shared/components/pageHeader/PageHeader"
import { LocalizedStrict } from "../../../../localization/components/AppLocalized"
import { Page } from "../../../../../shared/components/pageHeader/PageHeaderApi"
import { SUPPORT_ADMIN_ROUTE } from "../../../../../constants/routes"
import {
    Breadcrumb,
    BreadcrumbLink,
    StandardBreadcrumbs,
} from "../../../../../shared/components/links/StandardBreadcrumbs"
import { DeviceTable } from "../../../../entities/devices/components/DeviceTable"
import { useApiQueryTable } from "../../../../../core/api/components/ApiQueryTable"
import { DeviceTableVariant } from "../../../../entities/devices/deviceTypes"
import { useApiQuery } from "../../../../../core/api/useApiQuery"
import { DevicesSupportAdminResponse, fetchAllDevices } from "../adminDevicesApi"

const selectDevices = (data: DevicesSupportAdminResponse) => data?.devices || []

function SupportDevicesTable() {
    const devicesResult = useApiQuery(fetchAllDevices, {
        queryName: "devices-for-support",
        dependencies: {},
        select: selectDevices,
    })
    const { ApiQueryTable } = useApiQueryTable(devicesResult)

    return <DeviceTable variant={DeviceTableVariant.SUPPORT} ApiQueryTable={ApiQueryTable} />
}

export function SupportDevices() {
    return (
        <>
            <LocalizedStrict id="support-admin-devices-page-header" attrs={{ title: true }}>
                <PageHeader
                    page={Page.SUPPORT_ADMIN_DEVICES}
                    title="Devices"
                    icon={<FontAwesomeIcon icon={faShieldCheck} />}
                >
                    <StandardBreadcrumbs>
                        <LocalizedStrict id="support-nav-item-home">
                            <BreadcrumbLink to={SUPPORT_ADMIN_ROUTE}>Home</BreadcrumbLink>
                        </LocalizedStrict>
                        <LocalizedStrict id="support-nav-item-devices">
                            <Breadcrumb>Devices</Breadcrumb>
                        </LocalizedStrict>
                    </StandardBreadcrumbs>
                </PageHeader>
            </LocalizedStrict>

            <QueryErrorBoundary>
                <Suspense fallback={<LoadingSpinner />}>
                    <SupportDevicesTable />
                </Suspense>
            </QueryErrorBoundary>
        </>
    )
}
